/**
 * Academy domain — request/query parameter shapes for custom endpoints and OData.
 */
import type { DateTimeUtc, LearningProgressStatus, MineSubscriptionScope, OwnerType, ProductType } from './academy-enums.model';

/** `GET /LiveEvents/recordings` filters. All optional. */
export interface RecordingsQuery {
  product?: ProductType;
  search?: string;
  /** `ScheduledStartOnUtc >=` */
  from?: DateTimeUtc;
  /** `ScheduledStartOnUtc <=` */
  to?: DateTimeUtc;
}

/** `GET /Courses/discover` and `GET /LearningPaths/discover` filters. */
export interface DiscoverQuery {
  product?: ProductType;
  search?: string;
}

/** Generic OData query options for `GET /{Set}` (subset enabled by the package). */
export interface ODataQuery {
  filter?: string;
  select?: string;
  expand?: string;
  orderby?: string;
  top?: number;
  skip?: number;
  count?: boolean;
}

/** `GET /metering` / admin metering commands. `period` is `YYYY-MM`. */
export interface MeteringQuery {
  period: string;
}

/** `POST /metering/close` parameters. */
export interface MeteringCloseParams {
  period: string;
  ownerType: OwnerType;
  ownerId: string;
}

/** `GET /Courses/mine` query params. `status` defaults to `all`. */
export interface MineCoursesQuery {
  status?: LearningProgressStatus | 'all';
  top?: number;
  skip?: number;
}

/** `GET /LearningPaths/mine` query params. `status` defaults to `all`. */
export interface MinePathsQuery {
  status?: LearningProgressStatus | 'all';
  top?: number;
  skip?: number;
}

/** `GET /LiveSubscriptions/mine` query params. `scope` defaults to `upcoming`. */
export interface MineSubscriptionsQuery {
  scope?: MineSubscriptionScope;
  top?: number;
  skip?: number;
}

/** Validates the `YYYY-MM` period format used by metering endpoints. */
export const PERIOD_KEY_PATTERN = /^\d{4}-\d{2}$/;
